import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";
import { IndicatorCell } from "../../../../common_nextgen/common_components/IndicatorCell/IndicatorCell";

const defaultParamData = {
  networkId: "",
  carrierId: "",
  description: "",
  regionCode: "",
};

const useSuperNetwork = (
  onSelect,
  hideModal,
  initalSelectParams,
  initialSelectMode,
  initialLookupType,
  selectParamsData
) => {

  const { axios_helper_no_header } = useAxios();
  const [selectParams, setSelectParams] = useState(initalSelectParams);
  const [selectMode, setSelectMode] = useState(initialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [disabledFields, setDisabledFields] = useState({});
  const [data, setData] = useState([]); /* Super Network Data */
  console.log("selectParamsDate: ", selectParamsData);
  const [paramsData, setParamsData] = useState(
    lookupType
      ? {
        ...defaultParamData,
        networkId: selectParamsData?.networkId,
        carrierId: selectParamsData?.carrierId,
        description: selectParamsData?.description,
        regionCode: selectParamsData?.regionCode,
      }
      : defaultParamData
  ); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const { ADD_SUPER_NETWORK, DISPLAY_SUPER_NETWORK, PHARMACY_NETWORK } =
    ROUTE_PATHS;

  const screen_title = "Super Network";

  const [screenNumber, setScreenNumber] = useState("RCSNH990");

  /* Search form fields that needs to be shown for filtering */

  const formFields = [
    {
      fieldLabel: "SNH Super Network ID",
      name: "networkId",
      label: "ID",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 6,
    },
    {
      fieldLabel: "CAR Carrier ID",
      name: "carrierId",
      label: "Carrier",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 6,
    },
    {
      fieldLabel: "REG Region Code",
      name: "regionCode",
      label: "Region",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 6,
    },
    {
      fieldLabel: "SNH Super Network Desc",
      name: "description",
      label: "Name",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 6,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const handleBack = () => {
    if (lookupType === "external") {
      // hideModal();
      const message = {
        type: "hideModal",
      };
      window.parent.postMessage(message, "*");
    } else {
      hideModal();
    }
  };

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: handleBack,
      button_key: "F12",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        const paramDataMap = new Map();
        selectParams.forEach(key => {
          if (rowData.hasOwnProperty(key["target"])) {
            paramDataMap.set(key["source"], rowData[key["target"]]);
          }
        });
        const paramData = Object.fromEntries(paramDataMap);
        if (lookupType !== "external") {
          onSelect(paramData);
        } else {
          window.parent.postMessage(
            {
              data: paramData,
              type: "responseData",
            },
            "*"
          );
        }
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCSNH004",
          parameters: {
            snhSuperNetworkId: rowData["networkId"],
            carCarrierId: rowData["carrierId"],
            snhSeqNbr: rowData["snhSeqNbr"],
            regRegionCode: rowData["regionCode"],
            snhSuperNetworkDesc: rowData["description"],
            workInitialProgramMode: "DSP",
          },
        };
        console.log("message", message);
        window.top?.postMessage(message, "*");
      },
    },
    {
      label: "Pharmacy Network",
      icon: <span className="material-icons">local_pharmacy</span>,
      command: () => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCSND002",
          parameters: {
            snhSuperNetworkId: rowData["networkId"],
            carCarrierId: rowData["carrierId"],
            snhSeqNbr: rowData["snhSeqNbr"],
            regRegionCode: rowData["regionCode"],
            snhNetworkType: rowData["networkType"],
          },
        };
        console.log("message", message);
        window.top?.postMessage(message, "*");
      },
    },
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Id",
      field: "networkId",
    },
    {
      header: "Carrier",
      field: "carrierId",
    },
    {
      header: "Region",
      field: "regionCode",
    },
    {
      header: "Type",
      field: "networkType",
    },
    {
      header: "Name",
      field: "description",
    },
    {
      header: "Indicators",
      field: "notesExists",
      body: (rowData) => (
        <IndicatorCell rowData={rowData} fields={["notesExists"]} tooltipContent={{ notesExists: "Notes" }} />
      ),
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "counter";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/superNetwork`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, selectedOption]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData, screenNumber: screenNumber });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/superNetwork/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      setLookupType("external");
      setSelectParams(paramData.params);
      // setParamsData(paramData.paramsData);
      setParamsData({
        ...paramsData,
        ...paramData.paramsData,
      });
      setSelectMode(selectMode);
      if (paramData?.disabledFields) {
        setDisabledFields(paramData?.disabledFields);
      }
      if (paramData?.screenNumber) {
        setScreenNumber(paramData?.screenNumber);
      }
    }
  };


  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    setSelectedOption,
    selectMode,
    lookupType,
    disabledFields
  };
};

export default useSuperNetwork;
